// extracted by mini-css-extract-plugin
module.exports = {"shopLogoPlaceholder":"ProductOfferImgWrapper-module__shopLogoPlaceholder___z+9a-"};